import { Link } from 'react-router-dom';

export default function ConverterHero() {
  const svgPattern = `data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E`;

  return (
    <section className="relative pt-32 pb-20 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-teal-900 via-slate-900 to-cyan-900"></div>
      
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-teal-500 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-cyan-500 rounded-full filter blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-flex items-center px-4 py-2 bg-teal-500/20 border border-teal-500/30 rounded-full mb-8">
            <i className="ri-file-pdf-line text-teal-400 mr-2 w-5 h-5 flex items-center justify-center"></i>
            <span className="text-teal-300 text-sm font-medium">专业 PDF 转换解决方案</span>
          </div>

          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Adobe PDF Converter
            <span className="block mt-2 bg-gradient-to-r from-teal-400 to-cyan-400 bg-clip-text text-transparent">
              高效文档转换工具
            </span>
          </h1>

          <p className="text-xl text-gray-300 mb-12 leading-relaxed">
            支持多种格式互转，保持原始文档格式和布局，提供批量处理和 API 集成能力，
            满足企业级文档转换需求
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contact"
              className="inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-teal-600 to-cyan-600 text-white rounded-lg font-semibold hover:from-teal-700 hover:to-cyan-700 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-line mr-2 w-5 h-5 flex items-center justify-center"></i>
              立即试用
            </a>
            <a
              href="/contact"
              className="inline-flex items-center justify-center px-8 py-4 bg-white/10 backdrop-blur-sm text-white border border-white/20 rounded-lg font-semibold hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-customer-service-line mr-2 w-5 h-5 flex items-center justify-center"></i>
              联系销售
            </a>
          </div>

          <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-3xl font-bold text-teal-400 mb-2">20+</div>
              <div className="text-sm text-gray-400">支持格式</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-teal-400 mb-2">99.9%</div>
              <div className="text-sm text-gray-400">转换准确率</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-teal-400 mb-2">10倍</div>
              <div className="text-sm text-gray-400">处理速度提升</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-teal-400 mb-2">24/7</div>
              <div className="text-sm text-gray-400">技术支持</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
